export const SHOW_MOBILE_WARNING_REQ = 'SHOW_MOBILE_WARNING_REQ';
export const SHOW_MOBILE_WARNING_OK = 'SHOW_MOBILE_WARNING_OK';
export const HIDE_MOBILE_WARNING_OK = 'HIDE_MOBILE_WARNING_OK';
